// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyCxtBOlrkDVMuDEpRZEtBGqIJkZL485Ysw',
    authDomain: 'alco-party-vs-net.firebaseapp.com',
    databaseURL: 'https://alco-party-vs-net.firebaseio.com',
    projectId: 'alco-party-vs-net',
    storageBucket: 'alco-party-vs-net.appspot.com',
    messagingSenderId: '205807223255',
    appId: '1:205807223255:web:dd5907fd81c8112ce5cb92',
    measurementId: 'G-BSJTER92WR'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
